function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tracking-tools",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_1069",
  "data-name": "Ellipse 1069",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 17,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_8317",
  "data-name": "Path 8317",
  transform: "translate(3 3)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.24,7.76l-2.12,6.36L7.76,16.24,9.88,9.88Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 16.23999977111816 7.760000228881836 L 9.880000114440918 9.880000114440918 L 7.760000228881836 16.23999977111816 L 14.11999988555908 14.11999988555908 L 16.23999977111816 7.760000228881836 M 16.2394847869873 3.759889602661133 C 17.28377151489258 3.759889602661133 18.30599594116211 4.169136047363281 19.06842994689941 4.931570053100586 C 20.1397590637207 6.002899169921875 20.51384925842285 7.587570190429688 20.03472900390625 9.024909973144531 L 17.91473007202148 15.38490962982178 C 17.5165901184082 16.57933044433594 16.57933044433594 17.5165901184082 15.38490962982178 17.91473007202148 L 9.024909973144531 20.03472900390625 C 8.610481262207031 20.17287445068359 8.183603286743164 20.24011039733887 7.760515213012695 20.24011039733887 C 6.716228485107422 20.24011039733887 5.694004058837891 19.83086395263672 4.931570053100586 19.06842994689941 C 3.860240936279297 17.99710083007813 3.486150741577148 16.41242980957031 3.965269088745117 14.97509002685547 L 6.085269927978516 8.615090370178223 C 6.483409881591797 7.420669555664063 7.420669555664063 6.483409881591797 8.615090370178223 6.085269927978516 L 14.97509002685547 3.965269088745117 C 15.38951873779297 3.827125549316406 15.81639671325684 3.759889602661133 16.2394847869873 3.759889602661133 Z",
  stroke: "none",
  fill: "#fff"
})));

var SvgTrackingTools = function SvgTrackingTools(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrackingTools, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tracking-tools.282316d0.svg";
export { ForwardRef as ReactComponent };